import { render } from "./AVBChart.vue?vue&type=template&id=1b25547c&ts=true"
import script from "./AVBChart.vue?vue&type=script&lang=ts"
export * from "./AVBChart.vue?vue&type=script&lang=ts"

import "./AVBChart.vue?vue&type=style&index=0&id=1b25547c&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__